<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-s-marketing text-blue" style="margin-right: 5px;"></i>签约品牌统计</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading" class="chart-container">
      <div ref="brandChart" style="width: 100%; height: 318px;"></div>
    </div>
  </el-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'BrandStatistics',
  props: {
    employeeId: {
      type: String,
      default: ''
    },
    targetType: {
      type: String,
      default: 'department'
    },
    url: {
      type: String,
      default: 'zhaoshang/zongjian/brandStatistics'
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      chart: null,
      data: {
        brandCount: {}
      }
    }
  },
  created () {
    // this.fetchData()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    async fetchData () {
      this.loading = true
      try {
        const params = {
          target: this.targetType
        }

        if (this.employeeId) {
          params.employeeId = this.employeeId
        }

        const { data: res } = await this.$http.get(this.url, {
          params
        })

        if (res.meta.status === 200) {
          this.data = res.data
          this.$nextTick(() => {
            this.initChart()
          })
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取签约品牌统计失败')
      } finally {
        this.loading = false
      }
    },
    initChart () {
      if (!this.$refs.brandChart) return

      if (this.chart) {
        this.chart.dispose()
      }

      this.chart = echarts.init(this.$refs.brandChart)

      const brands = Object.keys(this.data.brandCount).sort()
      const values = brands.map(brand => this.data.brandCount[brand])

      const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#8E44AD', '#3498DB', '#1ABC9C', '#E74C3C', '#F39C12']

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          data: brands
        },
        series: [
          {
            name: '签约品牌',
            type: 'pie',
            radius: ['30%', '60%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter: '{b}\n{c}家'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: brands.map((brand, index) => ({
              name: brand,
              value: values[index],
              itemStyle: {
                color: colors[index % colors.length]
              }
            }))
          }
        ]
      }

      this.chart.setOption(option)
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.chart-container {
  padding: 10px 0;
}
</style>
